import BalanceLogs from '../../modules/BalanceLogs/BalanceLogs';

function PageBalanceLogs() {
    return <BalanceLogs />;
}

export default PageBalanceLogs;
